/**
 * Filters a list of objects by excluding items that contain a specified keyword
 * within a given property.
 *
 * @template T - Type of items in the list.
 * @param {T[]} list - The list of objects to filter.
 * @param {keyof T} property - The property of each object to check for the keyword.
 * @param {string} keyword - The keyword to exclude from the results.
 * @returns {T[]} - A filtered list excluding items with the specified keyword in the given property.
 */
export const filterByExclusion = <T>(
  list: T[],
  property: keyof T,
  keyword: string,
): T[] => {
  return list?.filter((item) => {
    const value = item[property];
    return (
      typeof value === 'string' &&
      !value.toLowerCase().includes(keyword.toLowerCase())
    );
  });
};
